<template>
  <div class="vz-video-details">
    <div class="vz-description">
      <h4 class="vz-title">Descrição</h4>
      <p class="vz-value">{{ description.long }}</p>
    </div>

    <div
      class="vz-live"
      v-if="
        contentType === 'LIVE_VIDEO' ||
        (contentType === 'LECTURE' && !isHappening)
      "
    >
      <h4 class="vz-title">Status de transmissão</h4>
      <p class="vz-value">Transmitindo agora</p>
    </div>

    <div class="vz-genres" v-if="genres.length && !isLessonsType">
      <h4 class="vz-title">Gêneros</h4>
      <p class="vz-value">{{ genres.join(', ') }}</p>
    </div>

    <div class="vz-year" v-if="year && !isLessonsType">
      <h4 class="vz-title">Ano</h4>
      <p class="vz-value">{{ year }}</p>
    </div>

    <div class="vz-duration" v-if="duration">
      <h4 class="vz-title">Duração</h4>
      <p class="vz-value">{{ durationText }}</p>
    </div>

    <div class="vz-age-rating" v-if="ageRating">
      <h4 class="vz-title">Classificação</h4>
      <p class="vz-value">{{ ageRatingValue }}</p>
    </div>

    <div class="vz-cast" v-if="cast.length">
      <h4 class="vz-title">Elenco</h4>
      <ul class="vz-value">
        <li>{{ cast.join(', ') }}</li>
      </ul>
    </div>

    <div v-if="isLessonsType">
      <div class="vz-learning-goal" v-if="learningGoal">
        <h4 class="vz-title">Objetivo de aprendizagem</h4>
        <p class="vz-value">{{ learningGoal }}</p>
      </div>

      <div class="vz-target-audience" v-if="targetAudience">
        <h4 class="vz-title">Público alvo</h4>
        <p class="vz-value">{{ targetAudience }}</p>
      </div>

      <div class="vz-completion-criteria" v-if="completionCriteria">
        <h4 class="vz-title">Critério de conclusão</h4>
        <p class="vz-value">{{ completionCriteria }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoDetailsInfo',

  props: {
    description: {
      type: Object,
      default: {}
    },
    ageRating: {
      type: String,
      default: ''
    },
    cast: {
      type: Array,
      default: () => []
    },
    learningGoal: {
      type: String,
      default: ''
    },
    targetAudience: {
      type: String,
      default: ''
    },
    completionCriteria: {
      type: String,
      default: ''
    },
    contentType: {
      type: String,
      default: ''
    },
    year: {
      type: Number,
      default: 0
    },
    genres: {
      type: Array,
      default: () => []
    },
    duration: {
      type: Number,
      default: 0
    },
    isHappening: {
      type: Boolean,
      default: false
    },
    svod: {
      type: Boolean,
      default: false
    },
    tvod: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isLessonsType() {
      const lessonsTypes = ['COURSE'];

      return lessonsTypes.includes(this.contentType);
    },

    durationText() {
      const suffix = this.duration > 1 ? ' minutos' : ' minuto';
      const num = Math.round(this.duration);
      return num + suffix;
    },

    ageRatingValue() {
      if (this.ageRating.toUpperCase() === 'LIVRE') {
        return 'L';
      }
      return this.ageRating;
    }
  }
};
</script>

































































<style theme="light-theater" scoped>
.vz-video-details {
  padding: 32px 32px 16px;
  position: relative;
  font-size: 0.85em;
}

.vz-title {
  margin: 32px 0 8px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 1em;
  font-weight: normal;
}

.vz-description .vz-title,
.vz-live .vz-title,
.vz-age-rating .vz-title {
  display: none;
}

.vz-value {
  margin: 0 0 12px;
}

.vz-cast .vz-value {
  margin: 0 0 16px;
  padding: 0;
}

.vz-description .vz-value {
  margin-right: 16px;
}

.vz-cast li {
  display: inline-block;
  padding: 5px;
}

.vz-cast li + li {
  content: ', ';
}

.vz-age-rating {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 2em;
  height: 2em;
  border-radius: 3px;
  background-color: #ffffff;
  color: rgb(48, 48, 48);
  font-weight: bold;
  line-height: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vz-age-rating .vz-value {
  margin: 0;
  padding: 0;
}
</style>
